/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerFindAllQueryResponse, NotificationEmailDeliveriesControllerFindAllQueryParams, NotificationEmailDeliveriesControllerFindAll401, NotificationEmailDeliveriesControllerFindAll403 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationEmailDeliveriesControllerFindAll } from "../../clients/notification-email-deliveriesService/notificationEmailDeliveriesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationEmailDeliveriesControllerFindAllQueryKey = (params: NotificationEmailDeliveriesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/notification-email-deliveries'
}, ...(params ? [params] : [])] as const;
export type NotificationEmailDeliveriesControllerFindAllQueryKey = ReturnType<typeof notificationEmailDeliveriesControllerFindAllQueryKey>;
export function notificationEmailDeliveriesControllerFindAllQueryOptions(params?: NotificationEmailDeliveriesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationEmailDeliveriesControllerFindAllQueryKey(params);
  return queryOptions<NotificationEmailDeliveriesControllerFindAllQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindAll401 | NotificationEmailDeliveriesControllerFindAll403>, NotificationEmailDeliveriesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationEmailDeliveriesControllerFindAll(params, config);
    }
  });
}

/**
 * @description Per-delivery outcomes for the email pipeline. A job row covers a chunk of up to fifty deliveries, so the jobs list cannot answer what happened to one recipient.
 * @summary List notification email deliveries
 * {@link /api/v1/notification-email-deliveries}
 */
export function useNotificationEmailDeliveriesControllerFindAll<TData = NotificationEmailDeliveriesControllerFindAllQueryResponse, TQueryData = NotificationEmailDeliveriesControllerFindAllQueryResponse, TQueryKey extends QueryKey = NotificationEmailDeliveriesControllerFindAllQueryKey>(params?: NotificationEmailDeliveriesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<NotificationEmailDeliveriesControllerFindAllQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindAll401 | NotificationEmailDeliveriesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationEmailDeliveriesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...notificationEmailDeliveriesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindAll401 | NotificationEmailDeliveriesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}